module.exports = __webpack_public_path__ + "media/images/icons/outlined/node-expand-6701d61aa49189fb9ce6e934f782f598.svg";